__turbopack_context__.v({
  "UnlockDramaContent": "Drama-module__SI--aW__UnlockDramaContent",
  "active": "Drama-module__SI--aW__active",
  "arrows": "Drama-module__SI--aW__arrows",
  "bar": "Drama-module__SI--aW__bar",
  "captiondropdown": "Drama-module__SI--aW__captiondropdown",
  "centerbtn": "Drama-module__SI--aW__centerbtn",
  "close": "Drama-module__SI--aW__close",
  "commonBtn": "Drama-module__SI--aW__commonBtn",
  "container": "Drama-module__SI--aW__container",
  "controlbtns": "Drama-module__SI--aW__controlbtns",
  "desc": "Drama-module__SI--aW__desc",
  "dropdown": "Drama-module__SI--aW__dropdown",
  "dropdownContainer": "Drama-module__SI--aW__dropdownContainer",
  "edpisode_item": "Drama-module__SI--aW__edpisode_item",
  "ep_count": "Drama-module__SI--aW__ep_count",
  "ep_num": "Drama-module__SI--aW__ep_num",
  "ep_trailer": "Drama-module__SI--aW__ep_trailer",
  "episodebox": "Drama-module__SI--aW__episodebox",
  "episodelist": "Drama-module__SI--aW__episodelist",
  "heading": "Drama-module__SI--aW__heading",
  "hiddenCheckbox": "Drama-module__SI--aW__hiddenCheckbox",
  "iconbtns": "Drama-module__SI--aW__iconbtns",
  "inner_box": "Drama-module__SI--aW__inner_box",
  "joinBtn": "Drama-module__SI--aW__joinBtn",
  "langDropdown": "Drama-module__SI--aW__langDropdown",
  "lock": "Drama-module__SI--aW__lock",
  "logingroup": "Drama-module__SI--aW__logingroup",
  "loginlabel": "Drama-module__SI--aW__loginlabel",
  "modalBox": "Drama-module__SI--aW__modalBox",
  "modalBoxBg": "Drama-module__SI--aW__modalBoxBg",
  "modal_overlay": "Drama-module__SI--aW__modal_overlay",
  "musicbar": "Drama-module__SI--aW__musicbar",
  "overlay": "Drama-module__SI--aW__overlay",
  "pip": "Drama-module__SI--aW__pip",
  "pipAnimation": "Drama-module__SI--aW__pipAnimation",
  "playerBtns": "Drama-module__SI--aW__playerBtns",
  "playerbox": "Drama-module__SI--aW__playerbox",
  "playpausebtn": "Drama-module__SI--aW__playpausebtn",
  "playsharebtn": "Drama-module__SI--aW__playsharebtn",
  "progressBar": "Drama-module__SI--aW__progressBar",
  "range": "Drama-module__SI--aW__range",
  "seekbar": "Drama-module__SI--aW__seekbar",
  "spin": "Drama-module__SI--aW__spin",
  "spinner": "Drama-module__SI--aW__spinner",
  "timer": "Drama-module__SI--aW__timer",
  "volume": "Drama-module__SI--aW__volume",
  "volumebox": "Drama-module__SI--aW__volumebox",
});
